import useSWR from 'swr';
import { getNavigationData } from '@api/interfaces/componentApi';
import useCustomer from '@hooks/useCustomer';
import { useArticlePath } from '@root/contexts/ArticlePathContext';

function useNavigationData(articleUid: string) {
  const { customer } = useCustomer();
  const pageLabel = useArticlePath() ?? '';
  const shouldFetch = Boolean(customer) && Boolean(pageLabel);
  const key = {
    endpoint: '/articleNavigationMenuComponent',
    articleName: pageLabel,
  };
  const { data, isLoading } = useSWR(shouldFetch ? key : null, async ({ articleName }) => {
    const response = await getNavigationData(articleUid, articleName);
    return response.data as ArticleCMSNode;
  });

  return {
    data,
    isLoading,
  };
}

export default useNavigationData;
